var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"living-options-dwellings"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"dwellings"},[_c('h3',[_vm._v("Dwellings")]),_c('button',{staticClass:"btn btn-sm btn-primary mb-4",on:{"click":_vm.addDwelling}},[_vm._v("Add Dwelling")]),_c('div',{staticClass:"mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dwellingFilterText),expression:"dwellingFilterText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Filter dwellings"},domProps:{"value":(_vm.dwellingFilterText)},on:{"input":function($event){if($event.target.composing)return;_vm.dwellingFilterText=$event.target.value}}}),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showActiveOnly),expression:"showActiveOnly"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showActiveOnly)?_vm._i(_vm.showActiveOnly,null)>-1:(_vm.showActiveOnly)},on:{"change":function($event){var $$a=_vm.showActiveOnly,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showActiveOnly=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showActiveOnly=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showActiveOnly=$$c}}}}),_vm._v(" Show Active Only")])]),_c('v-table',{attrs:{"columns":[
            { 
              label: 'Label',
              field: 'label'
            },
            { 
              label: 'Builder',
              field: 'builderLabel.en',
              options: {
                sortable: true,
                return: function (fieldValue) {
                  return fieldValue
                }
              }
            },
            { 
              label: 'Attached to Lots', 
              field: 'associatedLots', 
              options: {
                sortable: false,
                return: function (fieldValue) {
                  if (fieldValue === 'Not Found') {
                    return '-'
                  } else {
                    return fieldValue.map(field => `<div>${field.label}</div>`).join('')
                  }
                },
              }
            },
          ],"rows":_vm.filteredDwellings,"show-active-toggle":_vm.activeUser.access.indexOf('live-toggle') !== -1,"save-action":"SAVE_DWELLING"},on:{"edit":function($event){return _vm.editDwelling($event._id)},"clone":function($event){return _vm.cloneDwelling($event)},"delete":function($event){return _vm.deleteDwelling($event._id)}}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }